import React from 'react';

import NotificationBar from '../../components/notification-bar/NotificationBar';

import scss from './ConsumerLayout.module.scss';

function ConsumerLayout({ Header, children }) {
  return (
    <div className={scss.background}>
      <div className={scss.pageLayout}>
        {Header ? Header : null}
        <main className={scss.main}>{children}</main>
      </div>

      <NotificationBar />
    </div>
  );
}

export default ConsumerLayout;
